import { render, staticRenderFns } from "./SEO.vue?vue&type=template&id=18d2c466&scoped=true"
import script from "./SEO.vue?vue&type=script&lang=js"
export * from "./SEO.vue?vue&type=script&lang=js"
import style0 from "./SEO.vue?vue&type=style&index=0&id=18d2c466&lang=less"
import style1 from "./SEO.vue?vue&type=style&index=1&id=18d2c466&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d2c466",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18d2c466')) {
      api.createRecord('18d2c466', component.options)
    } else {
      api.reload('18d2c466', component.options)
    }
    module.hot.accept("./SEO.vue?vue&type=template&id=18d2c466&scoped=true", function () {
      api.rerender('18d2c466', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemsettings/components/SEO.vue"
export default component.exports